if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();

        // 🎯 Obtener el código de idioma seleccionado
        const selectedLang = event.currentTarget.dataset.lang || event.currentTarget.dataset.value;
        const selectedValue = event.currentTarget.dataset.value;
        const isForceLang = event.currentTarget.dataset.forceLang === 'true';

        // Obtener el texto del idioma seleccionado para actualizar la UI
        const selectedText = event.currentTarget.textContent.trim();

        // Si el idioma está disponible en el market, usar comportamiento normal (submit del form)
        if (!isForceLang) {
          // Actualizar el input antes del submit
          this.elements.input.value = event.currentTarget.dataset.value;

          // Actualizar visualmente el idioma seleccionado ANTES del submit
          const buttonText = this.elements.button.querySelector('.localization-form.text_underline');
          if (buttonText) {
            buttonText.textContent = selectedText;
          }

          // Actualizar clases activas
          this.querySelectorAll('.disclosure__link').forEach((item) => {
            item.classList.remove('disclosure__link--active');
          });
          event.currentTarget.classList.add('disclosure__link--active');

          // Cerrar el panel
          this.hidePanel();

          // Pequeño delay para que el usuario vea el cambio visual antes del submit
          requestAnimationFrame(() => {
            // Hacer submit normal para respetar el redirect del market
            const form = this.querySelector('form');
            if (form) form.submit();
          });
          return;
        }

        // Si el idioma NO está en el market (forzado), forzar redirect a URL específica
        // Convertir a minúsculas para comparación case-insensitive
        const langLower = selectedLang ? selectedLang.toLowerCase() : '';
        const valueLower = selectedValue ? selectedValue.toLowerCase() : '';

        // 🌍 Lógica de redirección específica para cada idioma forzado
        const currentPath = window.location.pathname;
        const currentSearch = window.location.search;
        let cleanPath = currentPath;
        const prefixes = ['/en-en', '/it-it', '/pt-pt', '/fr-fr'];
        
        for (const p of prefixes) {
          if (cleanPath.startsWith(p)) {
            cleanPath = cleanPath.substring(p.length);
            break;
          }
        }
        
        if (cleanPath === '/') cleanPath = '';

        let redirectUrl = null;

        // Español → raíz
        if (langLower === 'es' || valueLower === 'es' || valueLower.startsWith('es')) {
          redirectUrl = window.location.origin + cleanPath + currentSearch;
        }
        // Inglés → /en-en
        else if (langLower === 'en' || langLower === 'en-en' || valueLower.startsWith('en')) {
          redirectUrl = window.location.origin + '/en-en' + cleanPath + currentSearch;
        }
        // Italiano → /it-it
        else if (langLower === 'it' || langLower === 'it-it' || valueLower.startsWith('it')) {
          redirectUrl = window.location.origin + '/it-it' + cleanPath + currentSearch;
        }
        // Portugués → /pt-pt
        else if (langLower === 'pt' || langLower === 'pt-pt' || valueLower.startsWith('pt')) {
          redirectUrl = window.location.origin + '/pt-pt' + cleanPath + currentSearch;
        }
        // Francés → /fr-fr
        else if (langLower === 'fr' || langLower === 'fr-fr' || valueLower.startsWith('fr')) {
          redirectUrl = window.location.origin + '/fr-fr' + cleanPath + currentSearch;
        }

        // Si hay una redirección específica, redirigir inmediatamente
        if (redirectUrl) {
          window.location.href = redirectUrl;
          return;
        }

        // Fallback: si no se encontró una redirección específica, hacer submit normal
        this.elements.input.value = event.currentTarget.dataset.value;
        const form = this.querySelector('form');
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}

if (!customElements.get('goa-lang-localization-form')) {
  customElements.define(
    'goa-lang-localization-form',
    class LocalizationgoaLanForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          ele: this.querySelector('.disclosure__lan--value'),
          smb: this.querySelector('.button-submit-language'),
          closebtn: this.querySelector('.disclosure__lan--close'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.ele.addEventListener('click', this.openPopUp.bind(this));
        this.elements.smb.addEventListener('click', this.onSubmitForm.bind(this));
        this.elements.closebtn.addEventListener('click', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      openPopUp() {
        this.querySelector('.disclosure__list').classList.toggle('active');
      }

      onItemClick(event) {
        event.preventDefault();
        this.elements.input.value = event.currentTarget.dataset.value;
        this.elements.ele.value = event.currentTarget.dataset.value;

        // 🎯 Obtener el código de idioma seleccionado
        const selectedLang = event.currentTarget.dataset.lang;
        const selectedValue = event.currentTarget.dataset.value;
        const isForceLang = event.currentTarget.dataset.forceLang === 'true';

        // Obtener el contenido HTML del idioma seleccionado (incluye texto y bandera)
        const selectedContent = event.currentTarget.innerHTML;

        // Si el idioma está disponible en el market, NO forzar redirect (se manejará en onSubmitForm)
        if (!isForceLang) {
          // Actualizar visualmente el idioma seleccionado en el popup ANTES del submit
          const langValueElement = this.querySelector('.disclosure__lan--value-input');
          if (langValueElement) {
            // Clonar el contenido del link seleccionado
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = selectedContent;

            // Actualizar el texto
            const textSpan = langValueElement.querySelector('.localization-form.text_underline');
            if (textSpan) {
              // Extraer solo el texto (sin espacios extra ni banderas)
              const textContent = tempDiv.cloneNode(true);
              // Remover cualquier SVG o elemento de bandera
              textContent.querySelectorAll('svg, [class*="icon"]').forEach((el) => el.remove());
              textSpan.textContent = textContent.textContent.trim();
            }

            // Actualizar la bandera: remover la anterior y agregar la nueva
            const existingFlag = langValueElement.querySelector('svg, [class*="goa-icon"]');
            if (existingFlag) {
              existingFlag.remove();
            }

            // Agregar la bandera del idioma seleccionado si existe
            const selectedFlag = tempDiv.querySelector('svg, [class*="goa-icon"]');
            if (selectedFlag) {
              langValueElement.appendChild(selectedFlag.cloneNode(true));
            }
          }

          // Actualizar clases activas
          this.querySelector('.disclosure__list').classList.remove('active');
          this.querySelectorAll('.disclosure__link').forEach((item) => {
            item.classList.remove('disclosure__link--active');
          });
          if (event.currentTarget) {
            event.currentTarget.classList.add('disclosure__link--active');
          }

          // El submit se hará cuando el usuario haga click en el botón "Continuar"
          // La actualización visual ya está hecha arriba
          return;
        }

        // Si el idioma NO está en el market (forzado), forzar redirect a URL específica
        // Convertir a minúsculas para comparación case-insensitive
        const langLower = selectedLang ? selectedLang.toLowerCase() : '';
        const valueLower = selectedValue ? selectedValue.toLowerCase() : '';

        // 🌍 Lógica de redirección específica para cada idioma forzado
        const currentPath = window.location.pathname;
        const currentSearch = window.location.search;
        let cleanPath = currentPath;
        const prefixes = ['/en-en', '/it-it', '/pt-pt', '/fr-fr'];
        
        for (const p of prefixes) {
          if (cleanPath.startsWith(p)) {
            cleanPath = cleanPath.substring(p.length);
            break;
          }
        }
        
        if (cleanPath === '/') cleanPath = '';

        let url = null;

        // Español → raíz
        if (langLower === 'es' || valueLower === 'es' || valueLower.startsWith('es')) {
          url = window.location.origin + cleanPath + currentSearch;
        }
        // Inglés → /en-en
        else if (langLower === 'en' || langLower === 'en-en' || valueLower.startsWith('en')) {
          url = window.location.origin + '/en-en' + cleanPath + currentSearch;
        }
        // Italiano → /it-it
        else if (langLower === 'it' || langLower === 'it-it' || valueLower.startsWith('it')) {
          url = window.location.origin + '/it-it' + cleanPath + currentSearch;
        }
        // Portugués → /pt-pt
        else if (langLower === 'pt' || langLower === 'pt-pt' || valueLower.startsWith('pt')) {
          url = window.location.origin + '/pt-pt' + cleanPath + currentSearch;
        }
        // Francés → /fr-fr
        else if (langLower === 'fr' || langLower === 'fr-fr' || valueLower.startsWith('fr')) {
          url = window.location.origin + '/fr-fr' + cleanPath + currentSearch;
        }

        // Si hay una redirección específica, redirigir inmediatamente
        if (url) {
          window.location.href = url;
          return; // Salir inmediatamente
        }

        // Si llegamos aquí y es forzado pero no se encontró URL, hacer submit normal como fallback
        // (no debería pasar, pero por seguridad)
        this.querySelector('.disclosure__list').classList.remove('active');
        this.querySelectorAll('.disclosure__link').forEach((item) => {
          item.classList.remove('disclosure__link--active');
        });
        if (event.currentTarget) {
          event.currentTarget.classList.add('disclosure__link--active');
        }
      }

      onSubmitForm() {
        const selectedValue = this.elements.input.value;
        const selectedLang = this.elements.input.value.replace('-PT', '');

        // Buscar el elemento del idioma seleccionado para verificar si es forzado
        const selectedLink = this.querySelector(`[data-value="${selectedValue}"]`);
        const isForceLang = selectedLink ? selectedLink.dataset.forceLang === 'true' : false;

        // Si el idioma está disponible en el market, usar comportamiento normal (submit del form)
        if (!isForceLang) {
          // Hacer submit normal para respetar el redirect del market
          const form = this.querySelector('form');
          if (form) form.submit();
          return;
        }

        // Si el idioma NO está en el market (forzado), forzar redirect a URL específica
        // Convertir a minúsculas para comparación case-insensitive
        const langLower = selectedLang ? selectedLang.toLowerCase() : '';
        const valueLower = selectedValue ? selectedValue.toLowerCase() : '';

        // 🌍 Lógica de redirección específica para cada idioma forzado
        const currentPath = window.location.pathname;
        const currentSearch = window.location.search;
        let cleanPath = currentPath;
        const prefixes = ['/en-en', '/it-it', '/pt-pt', '/fr-fr'];
        
        for (const p of prefixes) {
          if (cleanPath.startsWith(p)) {
            cleanPath = cleanPath.substring(p.length);
            break;
          }
        }
        
        if (cleanPath === '/') cleanPath = '';

        let redirectUrl = null;

        // Español → raíz
        if (langLower === 'es' || valueLower === 'es' || valueLower.startsWith('es')) {
          redirectUrl = window.location.origin + cleanPath + currentSearch;
        }
        // Inglés → /en-en
        else if (langLower === 'en' || langLower === 'en-en' || valueLower.startsWith('en')) {
          redirectUrl = window.location.origin + '/en-en' + cleanPath + currentSearch;
        }
        // Italiano → /it-it
        else if (langLower === 'it' || langLower === 'it-it' || valueLower.startsWith('it')) {
          redirectUrl = window.location.origin + '/it-it' + cleanPath + currentSearch;
        }
        // Portugués → /pt-pt
        else if (langLower === 'pt' || langLower === 'pt-pt' || valueLower.startsWith('pt')) {
          redirectUrl = window.location.origin + '/pt-pt' + cleanPath + currentSearch;
        }
        // Francés → /fr-fr
        else if (langLower === 'fr' || langLower === 'fr-fr' || valueLower.startsWith('fr')) {
          redirectUrl = window.location.origin + '/fr-fr' + cleanPath + currentSearch;
        }

        // Si hay una redirección específica, redirigir inmediatamente
        if (redirectUrl) {
          window.location.href = redirectUrl;
          return;
        }

        // Fallback: si no se encontró una redirección específica, hacer submit normal
        const form = this.querySelector('form');
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
